module.exports = require("./ca-ES-valencia.d.ts");